import { Button, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { ArrowDownward, Edit, TramRounded } from "@material-ui/icons";
import _ from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatTimestamp, getBranchById } from "../../../utilities/common";
import ResendOrderFilter from "../ResendOrderFilter";
import PrintIcon from '@material-ui/icons/Print';

const useStyles = makeStyles((theme)=> ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between'
    }
}))

function TableCellWithTransition(props){
    const {oldValue, newValue, hasButton, buttonAction, type} = props
    const classes = useStyles();

    return (
        <TableCell align="center">
            <div className={classes.tableCell}>
                {   
                    type !== 'print' &&
                    <Typography align='center' style={{alignSelf: 'center'}}>{oldValue}</Typography>
                }
                {hasButton ?
                    <IconButton size='small'>
                        { type === 'edit' && <Edit onClick={()=>{buttonAction(oldValue)}}/> }
                        { type === 'print' && <PrintIcon onClick={()=>{buttonAction(newValue)}}/> }
                    </IconButton>
                    :
                    null
                }
            </div>
            {
                newValue !== undefined && newValue !== "Invalid date" && type !== 'print' ?
                <div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <ArrowDownward color='primary'/>
                    </div>
                    <div className={classes.tableCell}>
                        <Typography align='center' color='primary' style={{alignSelf: 'center'}}>{newValue}</Typography>
                        {hasButton ?
                            <IconButton size='small' onClick={()=>{buttonAction(newValue)}}><Edit/></IconButton>
                            :
                            null
                        }
                    </div>
                </div>
                :
                null
            }
        </TableCell>
    )
}

function ResendOrderTable(props){
    const {rows, columns, filterModel} = props;
    const classes = useStyles();
    const {t} = useTranslation("resendOrders");

    const [filters, setFilters] = useState([]);

    const filterData = () => {
        if(filters.length <= 0){
            return rows
        }
        let result = _.filter(rows, (row) => {
            return row[filters[0].field] === filters[0].value
        })
        _.forEach(filters, (filter, index) => {
            if(index !== 0) {
                let filtered = _.filter(rows, (row) => {
                    return row[filter.field] === filter.value
                })
                result = result.filter(value => filtered.includes(value));
            }
        })

        return result
    }

    return (
        <React.Fragment>
            <ResendOrderFilter
                filterModel={filterModel}
                onFilterChange={(filters)=>{setFilters(filters)}}
            />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell
                                    key={`table-header-${index}`}
                                    align={column.align !== undefined ? column.align: 'inherit'}
                                    width={column.width !== undefined ? column.width: ''}
                                >
                                    {t(column.headerName)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filterData().sort((a,b) => a.id - b.id).map((row) => (
                            <TableRow key={row.id} className={classes.root}>
                                {columns.map((column, index) => (
                                    <TableCellWithTransition
                                        key={`table-body-${index}`}
                                        oldValue={
                                            column.valueGetter !== undefined ? 
                                                column.valueGetter(row[column.field])
                                                :
                                                row[column.field]
                                        } 
                                        newValue={
                                            column.valueGetter !== undefined ? 
                                                column.valueGetter(row[`new_${column.field}`])
                                                :
                                                row[`new_${column.field}`]
                                        }
                                        hasButton={column.hasButton}
                                        buttonAction={column.buttonAction}
                                        type={column.type}
                                    />
                                ))}
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    )
}

ResendOrderTable.defaultProps = {
    columns: []
}

export default ResendOrderTable